/** localStorage draft for other-product category on /survey/prevbrand-other. */

export const OTHER_PRODUCT_TYPE_STORAGE_KEY = 'ldsurvey:otherProductType';

export const OTHER_PRODUCT_CATEGORIES = ['RMC', 'VAPE', 'RRP'] as const;

export type OtherProductCategory = (typeof OTHER_PRODUCT_CATEGORIES)[number];

export type OtherProductTypeAnswers = {
  category: OtherProductCategory | '';
};

export function isOtherProductCategory(value: unknown): value is OtherProductCategory {
  return OTHER_PRODUCT_CATEGORIES.includes(value as OtherProductCategory);
}

export function readOtherProductTypeAnswers(): OtherProductTypeAnswers {
  try {
    const raw = localStorage.getItem(OTHER_PRODUCT_TYPE_STORAGE_KEY);
    if (!raw) return { category: '' };
    const parsed = JSON.parse(raw) as unknown;
    if (typeof parsed !== 'object' || parsed === null) return { category: '' };
    const category = (parsed as Record<string, unknown>).category;
    return { category: isOtherProductCategory(category) ? category : '' };
  } catch {
    return { category: '' };
  }
}

export function writeOtherProductTypeAnswers(data: OtherProductTypeAnswers): void {
  try {
    localStorage.setItem(OTHER_PRODUCT_TYPE_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function clearOtherProductTypeAnswers(): void {
  try {
    localStorage.removeItem(OTHER_PRODUCT_TYPE_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isOtherProductTypeComplete(): boolean {
  return isOtherProductCategory(readOtherProductTypeAnswers().category);
}
